import { useEffect, useState } from 'react';
import { Heading, Inline, Stack, Text, textVariants, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { m as motion } from 'framer-motion';

const loaderStepStyles = css`
  border-radius: 16px;
  height: 9px;
  width: 78px;
`;

const wrapperStyles = css`
  display: grid;
  max-width: 540px;
`;

const messageWrapperStyles = css`
  grid-area: 1/2;
`;

const TextRotator = () => {
  const { t } = useTranslation();
  const [animationPosition, setAnimationPosition] = useState(0);
  const texts = [
    {
      heading: t('Result.MetaToBrandLoader.Rotating.Subheading.1'),
      text: t('Result.MetaToBrandLoader.Rotating.Text.1'),
    },
    {
      heading: t('Result.MetaToBrandLoader.Rotating.Subheading.2'),
      text: t('Result.MetaToBrandLoader.Rotating.Text.2'),
    },
    {
      heading: t('Result.MetaToBrandLoader.Rotating.Subheading.3'),
      text: t('Result.MetaToBrandLoader.Rotating.Text.3'),
    },
  ];

  useEffect(() => {
    const textsLength = texts.length - 1;
    const timeout = setTimeout(() => {
      if (animationPosition !== textsLength) {
        setAnimationPosition(animationPosition + 1);
        return;
      }
      setAnimationPosition(0);
    }, 6000);

    return () => {
      clearTimeout(timeout);
    };
  }, [animationPosition, texts.length]);

  return (
    <>
      <div className={wrapperStyles}>
        {texts.map(({ heading, text }, index) => (
          <Stack
            align="center"
            animate={{ opacity: animationPosition === index ? 1 : 0 }}
            as={motion.div}
            className={messageWrapperStyles}
            initial={false}
            key={index}
            spacing={8}
            style={{ zIndex: animationPosition === index ? 1 : 0 }}
            transition={{ duration: 0.5 }}
          >
            <Heading as="h3" level={4}>
              {heading}
            </Heading>
            <Text as="p" variant={textVariants._16}>
              {text}
            </Text>
          </Stack>
        ))}
      </div>
      <Inline>
        {texts.map((_text, index) => (
          <motion.div
            animate={{
              backgroundColor:
                animationPosition === index ? vars.colors.decoration.dark : vars.colors.divider,
            }}
            className={loaderStepStyles}
            initial={false}
            key={index}
            transition={{ duration: 0.25 }}
          />
        ))}
      </Inline>
    </>
  );
};

export default TextRotator;
